import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "./style.css";
import BlogCard from "../../../common/BlogCard";
import Service from "../../../services/Service";

const MediaCenter = () => {
	const [data, setData] = useState([]);
	const { t } = useTranslation();

	useEffect(() => {
		new Service().getList("mediaCenter").then((res) => {
			if (res.status === 200) {
				let response = res?.data?.data?.data;
				if (!!response?.length) {
					setData(response);
				}
			}
		});
	}, []);

	return (
		<div className="media-center" id="media-center">
			<div className="container">
				<p className="title">{t("Media Center")}</p>
				<Swiper
					slidesPerView={2}
					spaceBetween={24}
					pagination={{
						clickable: true,
					}}
					navigation
					scrollbar={{ draggable: true }}
					modules={[Navigation]}
					breakpoints={{
						640: {
							slidesPerView: 2,
							spaceBetween: 10,
						},
						768: {
							slidesPerView: 2,
							spaceBetween: 16,
						},
						1024: {
							slidesPerView: 3,
							spaceBetween: 24,
						},
					}}
					className="mySwiper"
					data-aos="zoom-in">
					{data?.map((blog, index) => {
						return (
							<SwiperSlide key={index}>
								<BlogCard item={blog} />
							</SwiperSlide>
						);
					})}
				</Swiper>
			</div>
		</div>
	);
};
export default MediaCenter;
